module.exports = __webpack_public_path__ + "static/media/trinity-logo-dark-transparent.db34f0e8.png";